import { Link, Stack, Typography } from '@mui/material';

import { links } from '@/localization';

import { ModelsAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';
import { EmptyStateButton } from '../../sections/EmptyStateContainer/EmptyStateButton';
import BasetenIcon from '../../sections/EmptyStateContainer/icons/BasetenIcon';
import DeepSeekIcon from '../../sections/EmptyStateContainer/icons/DeepSeekIcon';
import MetaIcon from '../../sections/EmptyStateContainer/icons/MetaIcon';
import QwenIcon from '../../sections/EmptyStateContainer/icons/QwenIcon';

function EmptyState() {
  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={600} gap={4}>
        <ModelsAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t deployed any models yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Quickly deploy and scale production-grade models with full control. Package any model
            for production with your code, frameworks, and dependencies.{' '}
            <Link href={links.basetenDocsDevelopingAModelOverview} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        <Stack gap={2} maxWidth={430} width="100%">
          <Typography variant="h5" textAlign="center">
            Try one of these to get started, or{' '}
            <Link href={links.basetenDocsDeployingYourFirstModel} target="_blank">
              deploy your own
            </Link>
            .
          </Typography>
          <EmptyStateButton
            href={links.basetenModelLibraryDeepSeek}
            target="_blank"
            icon={<DeepSeekIcon />}
          >
            DeepSeek
          </EmptyStateButton>
          <EmptyStateButton
            href={links.basetenModelLibraryLlama}
            target="_blank"
            icon={<MetaIcon />}
          >
            LLaMA
          </EmptyStateButton>
          <EmptyStateButton
            href={links.basetenModelLibraryQwen}
            target="_blank"
            icon={<QwenIcon />}
          >
            Qwen
          </EmptyStateButton>
          <EmptyStateButton href={links.basetenModelLibrary} target="_blank" icon={<BasetenIcon />}>
            Explore more
          </EmptyStateButton>
        </Stack>
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
